import { defineMessages } from 'react-intl';

const messages = defineMessages({
  cannotAddProductToItself: {
    defaultMessage: 'Cannot add product to itself',
    description: 'productTypeAhead.cannotAddProductToItself',
    id: 'V3hDgs',
  },
  cannotAddBundleProductToBundle: {
    defaultMessage: 'Cannot add bundle product to bundle',
    description: 'productTypeAhead.cannotAddBundleProductToBundle',
    id: 'sOAZ4X',
  },
});

export default messages;
